/* ============================================
   BeeLive Studio — bee-lightbox.js — 21/09/2026
   ============================================

   ⚠️ CE FICHIER NE CONTIENT PLUS DE LIGHTBOX.

   Les deux lightbox (catalogue le 27/08/2026, configurateur le 21/09/2026)
   ont été supprimées. Le NOM du fichier est conservé volontairement : la
   balise <script> de layout/theme.liquid n'a pas besoin d'être modifiée.

   Il ne reste qu'une fonction utile :
     · beeSessionRandom — tirage aléatoire stable pour la visite, utilisé par
       assets/bee-produits-lies.js (section « BEE — Produits liés » et
       suggestions du configurateur).
       ⚠️ Ne pas supprimer ce fichier sans déplacer cette fonction.

   Supprimé le 21/09/2026 : beeForceCloseLightboxes et la consigne
   sessionStorage « beeCloseLb », qui ne servaient plus qu'à la lightbox
   du configurateur.
   ============================================ */

(function () {
  'use strict';

  /* Le navigateur replace la page lui-même au retour arrière, progressivement
     et sans animation. Bien plus propre que n'importe quel repositionnement
     en JavaScript. */
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'auto';
  }

  /* ── beeSessionRandom ──────────────────────────────────────────────────
     Tirage aléatoire STABLE pour la durée de la visite : une graine unique
     gardée en session, combinée à la clé passée en argument. Même page
     rechargée = mêmes recommandations, au lieu d'une sélection qui change à
     chaque rafraîchissement.
     Appelée par assets/bee-produits-lies.js, qui a un repli sur Math.random :
     sans elle rien ne plante, mais on perd la stabilité sans s'en apercevoir.
     ────────────────────────────────────────────────────────────────────── */
  function beeSessionRandom(key) {
    var seed;
    try { seed = sessionStorage.getItem('beeSeed'); } catch (e) {}
    if (!seed) {
      seed = String(Math.floor(Math.random() * 1e9));
      try { sessionStorage.setItem('beeSeed', seed); } catch (e) {}
    }
    var h = 2166136261 ^ (parseInt(seed, 10) || 1);
    key = String(key || '');
    for (var i = 0; i < key.length; i++) { h ^= key.charCodeAt(i); h = Math.imul(h, 16777619); }
    var t = h >>> 0;
    return function () {
      t += 0x6D2B79F5;
      var r = Math.imul(t ^ (t >>> 15), 1 | t);
      r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }
  window.beeSessionRandom = beeSessionRandom;

  /* Nettoyage : une ancienne consigne a pu rester en session. */
  try { sessionStorage.removeItem('beeCloseLb'); } catch (e) {}
})();